import { IconProps } from "@design-system/types";

export function GlobeIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66669 15.9998C2.66669 23.3638 8.63602 29.3332 16 29.3332C23.364 29.3332 29.3334 23.3638 29.3334 15.9998C29.3334 8.63584 23.364 2.6665 16 2.6665C8.63602 2.6665 2.66669 8.63584 2.66669 15.9998Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3334 2.7334C17.3334 2.7334 21.3334 8.00006 21.3334 16.0001C21.3334 24.0001 17.3334 29.2667 17.3334 29.2667M14.6667 29.2667C14.6667 29.2667 10.6667 24.0001 10.6667 16.0001C10.6667 8.00006 14.6667 2.7334 14.6667 2.7334M3.50671 20.6667H28.4934M3.50671 11.3334H28.4934"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
